(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ffw-banner-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ffw-banner]').forEach((root) => {
    if (root.dataset.ready === "1") return;
    root.dataset.ready = "1";
    const slides = [...root.querySelectorAll('[data-slide]')];
    const count = root.querySelector('[data-count]');
    if (!slides.length) return;
    let index = 0;
    const show = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      if (count) count.textContent = (index + 1) + ' / ' + slides.length;
    };
    root.querySelector('[data-prev]')?.addEventListener('click', () => show(index - 1));
    root.querySelector('[data-next]')?.addEventListener('click', () => show(index + 1));
    const seconds = Number(root.dataset.seconds || 6);
    let timer = setInterval(() => show(index + 1), seconds * 1000);
    root.addEventListener('mouseenter', () => clearInterval(timer));
    root.addEventListener('mouseleave', () => { timer = setInterval(() => show(index + 1), seconds * 1000); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
